import React from 'react'
import WithdrawalApprovals from '../components/admin/WithdrawalApprovals'

const AdminWithdrawals: React.FC = () => {
  return <WithdrawalApprovals />
}

export default AdminWithdrawals